import React from 'react'

type Props = {
  className?: string
  children: React.ReactNode
}

export const InfoDot = ({ className, children }: Props) => {
  return (
    <span
      className={`flex h-8 min-w-[32px] items-center justify-center rounded-full text-sm ${className}`}
    >
      {children}
    </span>
  )
}
